import { render } from "./TemplateModalCamera.vue?vue&type=template&id=18689e7a&ts=true"
import script from "./TemplateModalCamera.vue?vue&type=script&lang=ts"
export * from "./TemplateModalCamera.vue?vue&type=script&lang=ts"

import "./TemplateModalCamera.vue?vue&type=style&index=0&id=18689e7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__